import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { WarehouseService } from '../../../warehouses/warehouse.service';
import { Warehouse } from '../../sdk';
import { Observable, Subject } from 'rxjs';
import { takeUntil, map, switchMap, filter } from 'rxjs/operators';
import { OrganizationService } from '../../../organizations/organization.service';

@Component({
  selector: 'app-warehouse-select',
  templateUrl: './warehouse-select.component.html',
  styleUrls: ['./warehouse-select.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarehouseSelectComponent implements OnInit, OnDestroy {
  @Input() selectedWarehouseId = '';
  @Output() selected = new EventEmitter<string>();
  hasInventoryAddition = true;
  warehouseForm: FormGroup;
  warehouses: Observable<Warehouse[]>;
  private onDestroy$ = new Subject<void>();

  constructor(
    private fb: FormBuilder,
    private orgService: OrganizationService,
    private warehouseService: WarehouseService,
  ) {}

  ngOnInit(): void {
    this.warehouseForm = this.fb.group({
      warehouseId: this.selectedWarehouseId,
    });

    this.warehouseForm.controls.warehouseId.setValue(this.selectedWarehouseId);

    this.warehouseForm.controls.warehouseId.valueChanges
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((warehouseId) => this.onSelect(warehouseId));

    this.warehouses = this.orgService.active.pipe(
      filter((org) => !!org),
      switchMap((org) => this.warehouseService.get(org.id)),
      map(({ body }) => body),
      takeUntil(this.onDestroy$),
    );
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  onSelect(warehouseId: string): void {
    this.selected.emit(warehouseId);
  }
}
